import { render, staticRenderFns } from "./type-edit.vue?vue&type=template&id=40a546f0&scoped=true&"
import script from "./type-edit.vue?vue&type=script&lang=js&"
export * from "./type-edit.vue?vue&type=script&lang=js&"
import style0 from "./type-edit.vue?vue&type=style&index=0&id=40a546f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a546f0",
  null
  
)

export default component.exports